import React from 'react';

const overlay = {
  position: 'fixed', inset: 0, background: 'rgba(8,12,8,0.7)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 60,
};
const shell = {
  background: '#e9dab0', border: '3px double #5a4a1d',
  boxShadow: '0 12px 30px rgba(0,0,0,0.6)',
  width: 'min(96vw, 420px)', padding: 16,
  fontFamily: 'Georgia, "Times New Roman", serif',
  color: '#3a2b14',
};

export const BanUserModal = ({ open, onClose, onSubmit }) => {
  const [name, setName] = React.useState('');
  const [minutes, setMinutes] = React.useState('60');
  const [busy, setBusy] = React.useState(false);
  React.useEffect(() => { if (open) { setName(''); setMinutes('60'); setBusy(false); } }, [open]);
  if (!open) return null;
  const submit = async () => {
    if (!name.trim()) return;
    setBusy(true);
    try { await onSubmit(name.trim(), parseInt(minutes, 10) || 60); }
    finally { setBusy(false); onClose(); }
  };
  return (
    <div style={overlay} data-testid="ban-user-modal" onClick={onClose}>
      <div style={shell} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 10 }}>
          Ban a User
        </div>
        <div style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 11, marginBottom: 2 }}>Username</label>
          <input
            data-testid="ban-username"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. troublemaker"
            style={{ width: '100%', padding: '4px 6px', border: '1px solid #5a4a1d' }}
            autoFocus
          />
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ display: 'block', fontSize: 11, marginBottom: 2 }}>Length (minutes)</label>
          <input
            data-testid="ban-minutes"
            value={minutes}
            onChange={(e) => setMinutes(e.target.value.replace(/\D/g, ''))}
            placeholder="60 = 1 hour, 1440 = 1 day"
            style={{ width: '100%', padding: '4px 6px', border: '1px solid #5a4a1d' }}
          />
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{ background: '#5a4a1d', color: '#f5e6c0', border: '1px solid #3a2b14', padding: '4px 14px', fontWeight: 'bold', cursor: 'pointer' }}
          >Cancel</button>
          <button
            data-testid="ban-confirm"
            onClick={submit}
            disabled={busy || !name.trim()}
            style={{ background: '#8b1a1a', color: '#fff3d0', border: '1px solid #3a1a1a', padding: '4px 14px', fontWeight: 'bold', cursor: busy ? 'wait' : 'pointer' }}
          >{busy ? 'Banning…' : 'Confirm Ban'}</button>
        </div>
      </div>
    </div>
  );
};

export const PuppetNpcModal = ({ open, onClose, onSubmit, currentPuppet }) => {
  const [name, setName] = React.useState('');
  React.useEffect(() => { if (open) { setName(currentPuppet || ''); } }, [open, currentPuppet]);
  if (!open) return null;
  const submit = () => { onSubmit(name.trim() || null); onClose(); };
  return (
    <div style={overlay} data-testid="puppet-npc-modal" onClick={onClose}>
      <div style={shell} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 10 }}>
          Puppet an NPC / Monster
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ display: 'block', fontSize: 11, marginBottom: 2 }}>NPC / Monster name (leave blank to release)</label>
          <input
            data-testid="puppet-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Lyriana"
            style={{ width: '100%', padding: '4px 6px', border: '1px solid #5a4a1d' }}
            autoFocus
          />
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{ background: '#5a4a1d', color: '#f5e6c0', border: '1px solid #3a2b14', padding: '4px 14px', fontWeight: 'bold', cursor: 'pointer' }}
          >Cancel</button>
          <button
            data-testid="puppet-confirm"
            onClick={submit}
            style={{ background: '#6b3a92', color: '#f5e6c0', border: '1px solid #3a1a5a', padding: '4px 14px', fontWeight: 'bold', cursor: 'pointer' }}
          >{name.trim() ? 'Puppet' : 'Release'}</button>
        </div>
      </div>
    </div>
  );
};


// Msg #970 — Global announcement modal.  Goddess_Sophetia reads the text
// aloud across all public rooms.
export const AnnounceModal = ({ open, onClose, onSubmit }) => {
  const [text, setText] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  React.useEffect(() => { if (open) { setText(''); setBusy(false); } }, [open]);
  if (!open) return null;
  const submit = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { await onSubmit(text.trim()); }
    finally { setBusy(false); onClose(); }
  };
  return (
    <div style={overlay} data-testid="announce-modal" onClick={onClose}>
      <div style={shell} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 6 }}>
          📢 Announcement
        </div>
        <div style={{ fontSize: 11, marginBottom: 10, fontStyle: 'italic', opacity: 0.85 }}>
          Goddess_Sophetia will read this aloud across every public room, on behalf of the throne.
        </div>
        <div style={{ marginBottom: 10 }}>
          <textarea
            data-testid="announce-text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Write your proclamation…"
            rows={4}
            style={{ width: '100%', padding: '6px 8px', border: '1px solid #5a4a1d',
                     fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 13, resize: 'vertical' }}
            autoFocus
          />
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{ background: '#5a4a1d', color: '#f5e6c0', border: '1px solid #3a2b14',
                     padding: '4px 14px', fontWeight: 'bold', cursor: 'pointer' }}
          >Cancel</button>
          <button
            data-testid="announce-confirm"
            onClick={submit}
            disabled={busy || !text.trim()}
            style={{ background: '#c8a13a', color: '#3a2a1a', border: '1px solid #7a5a1a',
                     padding: '4px 14px', fontWeight: 'bold',
                     cursor: busy ? 'wait' : 'pointer' }}
          >{busy ? 'Proclaiming…' : 'Proclaim'}</button>
        </div>
      </div>
    </div>
  );
};


// Msg #986 — Admin: delete a user account (soft or hard).
export const DeleteUserAdminModal = ({ open, onClose, onSubmit }) => {
  const [name, setName] = React.useState('');
  const [hard, setHard] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  React.useEffect(() => { if (open) { setName(''); setHard(false); setBusy(false); } }, [open]);
  if (!open) return null;
  const submit = async () => {
    if (!name.trim()) return;
    setBusy(true);
    try { await onSubmit(name.trim(), hard); }
    finally { setBusy(false); onClose(); }
  };
  return (
    <div style={overlay} data-testid="delete-user-modal" onClick={onClose}>
      <div style={shell} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 6 }}>
          🗑 Delete a User
        </div>
        <div style={{ fontSize: 11, marginBottom: 10, fontStyle: 'italic', opacity: 0.85 }}>
          Removes the user from the approved-users store. Enable HARD DELETE
          to also wipe their chat lines, whispers, PMs, HP, and leaderboard
          entry. Admin accounts cannot be deleted through this tool.
        </div>
        <div style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 11, marginBottom: 2 }}>Username</label>
          <input
            data-testid="delete-user-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. spammer42"
            style={{ width: '100%', padding: '4px 6px', border: '1px solid #5a4a1d' }}
            autoFocus
          />
        </div>
        <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 12, marginBottom: 10 }}>
          <input
            data-testid="delete-user-hard"
            type="checkbox"
            checked={hard}
            onChange={(e) => setHard(e.target.checked)}
          />
          <span>Hard delete — also wipe chat, whispers, PMs, HP, leaderboard.</span>
        </label>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{ background: '#5a4a1d', color: '#f5e6c0', border: '1px solid #3a2b14',
                     padding: '4px 14px', fontWeight: 'bold', cursor: 'pointer' }}
          >Cancel</button>
          <button
            data-testid="delete-user-confirm"
            onClick={submit}
            disabled={busy || !name.trim()}
            style={{ background: '#3a0a0a', color: '#fce2d0',
                     border: '1px solid #7a1a1a', padding: '4px 14px',
                     fontWeight: 'bold', cursor: busy ? 'wait' : 'pointer' }}
          >{busy ? 'Deleting…' : (hard ? 'Hard Delete' : 'Delete')}</button>
        </div>
      </div>
    </div>
  );
};


// Msg #986 — Admin Shadow Whisper compose (red-themed distinct from Messenger).
// Sends a whisper with shadow=true — the recipient sees a red-tagged PM,
// and it is not attached to a normal Messenger conversation thread.
export const ShadowWhisperModal = ({ open, onClose, onSubmit, presenceNames }) => {
  const [to, setTo] = React.useState('');
  const [text, setText] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState('');
  React.useEffect(() => { if (open) { setTo(''); setText(''); setErr(''); setBusy(false); } }, [open]);
  if (!open) return null;
  const submit = async () => {
    setErr('');
    if (!to.trim()) { setErr('Recipient username required.'); return; }
    if (!text.trim()) { setErr('Message body required.'); return; }
    setBusy(true);
    try {
      await onSubmit(to.trim(), text.trim());
      onClose();
    } catch (e) {
      const d = e && e.response && e.response.data && e.response.data.detail;
      setErr(d || 'Failed to send shadow whisper.');
    } finally { setBusy(false); }
  };
  const shadowShell = {
    ...shell,
    background: '#2a0a0a',
    border: '3px double #7a1a1a',
    color: '#fce2d0',
    width: 'min(96vw, 480px)',
  };
  return (
    <div style={overlay} data-testid="shadow-whisper-modal" onClick={onClose}>
      <div style={shadowShell} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'uppercase',
                      letterSpacing: 2, marginBottom: 6, color: '#ff9a9a' }}>
          🥷 Shadow Whisper
        </div>
        <div style={{ fontSize: 11, marginBottom: 10, fontStyle: 'italic', opacity: 0.85 }}>
          Delivered privately in red to the recipient. Not tracked as a normal
          Messenger conversation. Admin-only.
        </div>
        <div style={{ marginBottom: 8 }}>
          <label style={{ display: 'block', fontSize: 11, marginBottom: 2 }}>To (username)</label>
          <input
            data-testid="shadow-whisper-to"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            placeholder="e.g. testuser"
            list="shadow-whisper-online-users"
            style={{ width: '100%', padding: '4px 6px',
                     border: '1px solid #7a1a1a', background: '#1a0505',
                     color: '#fce2d0' }}
            autoFocus
          />
          {Array.isArray(presenceNames) && presenceNames.length > 0 && (
            <datalist id="shadow-whisper-online-users">
              {presenceNames.map((n) => <option key={n} value={n} />)}
            </datalist>
          )}
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={{ display: 'block', fontSize: 11, marginBottom: 2 }}>Message</label>
          <textarea
            data-testid="shadow-whisper-text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={4}
            placeholder="Type your shadow whisper…"
            style={{ width: '100%', padding: '6px 8px',
                     border: '1px solid #7a1a1a', background: '#1a0505',
                     color: '#fce2d0', fontFamily: 'inherit',
                     fontSize: 13, resize: 'vertical' }}
          />
        </div>
        {err && (
          <div data-testid="shadow-whisper-error" style={{ color: '#ff9a9a', fontSize: 12, marginBottom: 6 }}>
            {err}
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{ background: '#3a0a0a', color: '#fce2d0',
                     border: '1px solid #7a1a1a', padding: '4px 14px',
                     fontWeight: 'bold', cursor: 'pointer' }}
          >Cancel</button>
          <button
            data-testid="shadow-whisper-send"
            onClick={submit}
            disabled={busy || !to.trim() || !text.trim()}
            style={{ background: '#a02020', color: '#fff3e0',
                     border: '1px solid #ff6060', padding: '4px 14px',
                     fontWeight: 'bold', cursor: busy ? 'wait' : 'pointer',
                     opacity: busy ? 0.7 : 1 }}
          >{busy ? 'Sending…' : 'Send Shadow'}</button>
        </div>
      </div>
    </div>
  );
};



// Msg #988 — Admin: grant stat points / overrides to a target user.
export const AddStatPointsModal = ({ open, onClose, onSubmit }) => {
  const [target, setTarget] = React.useState('');
  const [kills, setKills] = React.useState('1');
  const [hpMax, setHpMax] = React.useState('');
  const [mpMax, setMpMax] = React.useState('');
  const [atk, setAtk] = React.useState('');
  const [def, setDef] = React.useState('');
  const [healFull, setHealFull] = React.useState(true);
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState('');
  React.useEffect(() => {
    if (open) {
      setTarget(''); setKills('1'); setHpMax(''); setMpMax('');
      setAtk(''); setDef(''); setHealFull(true); setErr(''); setBusy(false);
    }
  }, [open]);
  if (!open) return null;
  const num = (s) => (s === '' || s == null ? null : parseInt(s, 10));
  const submit = async () => {
    setErr('');
    if (!target.trim()) { setErr('Target username required.'); return; }
    setBusy(true);
    try {
      await onSubmit({
        target: target.trim(),
        kills_delta: parseInt(kills || '0', 10) || 0,
        hp_max_override: num(hpMax),
        mp_max_override: num(mpMax),
        attack_override: num(atk),
        defense_override: num(def),
        heal_full: healFull,
      });
      onClose();
    } catch (e) {
      const d = e && e.response && e.response.data && e.response.data.detail;
      setErr(d || 'Stat points grant failed.');
    } finally { setBusy(false); }
  };
  const rowStyle = { display: 'flex', gap: 6, alignItems: 'center', marginBottom: 6 };
  const labelStyle = { minWidth: 130, fontSize: 12 };
  const inputStyle = {
    flex: 1, padding: '3px 6px', border: '1px solid #5a4a1d',
    fontFamily: 'inherit', fontSize: 12,
  };
  const shellDark = {
    ...shell,
    width: 'min(96vw, 460px)',
    background: '#f2e8c8',
    border: '2px solid #7a5a1a',
  };
  return (
    <div style={overlay} data-testid="add-stat-points-modal" onClick={onClose}>
      <div style={shellDark} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'uppercase',
                      letterSpacing: 2, marginBottom: 6 }}>⚡ Grant Stat Points</div>
        <div style={{ fontSize: 11, marginBottom: 10, fontStyle: 'italic', opacity: 0.85 }}>
          Kills auto-scale rank (Novice→…→Champion, +hp+mp+atk+def per tier).
          Direct overrides win over rank-derived caps. Empty = no change.
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>Target username</span>
          <input
            data-testid="stat-points-target"
            value={target}
            onChange={(e) => setTarget(e.target.value)}
            placeholder="e.g. testuser"
            style={inputStyle} autoFocus
          />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>Kills (delta)</span>
          <input
            data-testid="stat-points-kills"
            type="number"
            value={kills}
            onChange={(e) => setKills(e.target.value)}
            style={inputStyle}
          />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>HP max override</span>
          <input
            data-testid="stat-points-hp-max"
            type="number" value={hpMax}
            onChange={(e) => setHpMax(e.target.value)}
            placeholder="leave blank for rank default"
            style={inputStyle}
          />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>MP max override</span>
          <input
            data-testid="stat-points-mp-max"
            type="number" value={mpMax}
            onChange={(e) => setMpMax(e.target.value)}
            placeholder="leave blank for rank default"
            style={inputStyle}
          />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>Attack override</span>
          <input
            data-testid="stat-points-atk"
            type="number" value={atk}
            onChange={(e) => setAtk(e.target.value)}
            placeholder="leave blank"
            style={inputStyle}
          />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>Defense override</span>
          <input
            data-testid="stat-points-def"
            type="number" value={def}
            onChange={(e) => setDef(e.target.value)}
            placeholder="leave blank"
            style={inputStyle}
          />
        </div>
        <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 12,
                        marginBottom: 10 }}>
          <input
            data-testid="stat-points-heal-full"
            type="checkbox" checked={healFull}
            onChange={(e) => setHealFull(e.target.checked)}
          />
          <span>Heal target to full HP / MP after applying</span>
        </label>
        {err && (
          <div data-testid="stat-points-error" style={{ color: '#7a1f1f', fontSize: 12, marginBottom: 6 }}>
            {err}
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{ background: '#5a4a1d', color: '#f5e6c0',
                     border: '1px solid #3a2b14', padding: '4px 14px',
                     fontWeight: 'bold', cursor: 'pointer' }}
          >Cancel</button>
          <button
            data-testid="stat-points-submit"
            onClick={submit}
            disabled={busy}
            style={{ background: '#4a3a1a', color: '#ffe1a0',
                     border: '1px solid #a08a30', padding: '4px 14px',
                     fontWeight: 'bold', cursor: busy ? 'wait' : 'pointer',
                     opacity: busy ? 0.7 : 1 }}
          >{busy ? 'Granting…' : 'GRANT'}</button>
        </div>
      </div>
    </div>
  );
};
